import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProviderAllSubservices,
  getSubServices,
  PROVIDER_SUB_SERVICES_GET_MANY,
  resetState,
  StateStatus,
  SUBSERVICE_RESTORE,
} from '@guryou/redux';

const useSubServices = ({ serviceId, silent, all = false }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.subServices.all);
  const restore = useSelector(state => state.subServices.restore);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request?.serviceId !== serviceId)) {
      if (all) {
        dispatch(getProviderAllSubservices(serviceId, silent));
      } else {
        dispatch(getSubServices(serviceId, silent));
      }
    }
    if (restore.version) {
      dispatch(resetState(PROVIDER_SUB_SERVICES_GET_MANY));
      restore.version && dispatch(resetState(SUBSERVICE_RESTORE));
    }
  }, [all, dispatch, request, restore.version, serviceId, silent, status]);

  if (!serviceId) {
    return { data: null, status: StateStatus.NOT_INITIALIZED };
  }

  return { data: data || [], status, version, entity };
};

export default useSubServices;
